import { render, staticRenderFns } from "./storesDeposits.vue?vue&type=template&id=0d303742"
import script from "./storesDeposits.vue?vue&type=script&lang=js"
export * from "./storesDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports